import {useContext} from "react";
import {Link, useLocation} from "react-router-dom";
import DataContext from "../components/DataContext";
import styles from "../scss/MainPage.module.scss";
import {AiFillFolder} from "react-icons/ai";
import NotFound from "./NotFound";

const CategoryPage = () => {

    const route = useLocation();
    const {data} = useContext(DataContext);

    const routes = route.pathname.split("/");
    const children = data?.filter(el => el.name === routes[2])
                            .map(el => el.children || [])[0]
                            ?.filter(el => el.name === routes[3])
                            ?.map(el => el.children || [])[0]
                            ?.filter(el => el.name === routes[4])
                            ?.map(el => el.children || []);

    if(!children || (children.length === 0)) {
        return <NotFound/>
    }

   else {
        return (
            <div>
                {
                    children && children.length > 0 &&
                    (<ul className={styles.listStyle}>
                        {
                            data && data.length > 0 && children[0].map((item, idx) => {
                                if(item.children) {
                                    return ( <li key={idx}><Link to={{pathname: `${route.pathname}/${item.name}`}}><AiFillFolder/>{item.name}</Link> <hr></hr></li>)
                                }
                                else {
                                    return (<li key={idx}><AiFillFolder/>{item.name}<hr></hr></li>)
                                }
                            })
                        }
                    </ul>)
                }
            </div>
        )
    }

};

export default CategoryPage;